module.exports = __webpack_public_path__ + "static/img/footer_banner.be4bd92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/CustomersInfo/footer_banner.jpg
// module id = 7GDX
// module chunks = 19